export default "<div class=\"resultNumber\">\n  <!-- TODO : i18N -->\n  <span>{{numberKey}} Résultats(s)</span>\n</div>\n";